import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33b211a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = ["id"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "modal-footer" }

import $ from 'jquery';
  
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MiscNotesDialog',
  props: {
    modalid: {},
    title: {},
    notes: {}
  },
  setup(__props: any, { expose: __expose }) {

    const props = __props;

  const show = () => {
    if ($(`#${props.modalid}-modal` + 'Backdrop').length == 0) {
      const backdropDiv = $(`<div class="modal-backdrop fade show" id="${props.modalid}-modalBackdrop"></div>`);
      $('body').append(backdropDiv);
      $(`#${props.modalid}-modal`).show();
    }
  }
  const hide = (val: boolean) => {
    if ($(`#${props.modalid}-modal`).length > 0) {
      $(`#${props.modalid}-modal` + 'Backdrop').remove();
      $(`#${props.modalid}-modal`).hide();
    }
  };
  
  __expose({ show, hide });
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    id: `${_ctx.modalid}-modal`,
    "aria-labelledby": `${_ctx.modalid}-modal-label`,
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", {
            class: "modal-title",
            id: `${_ctx.modalid}-modal-label`
          }, _toDisplayString(_ctx.title), 9, _hoisted_5),
          _createElementVNode("button", {
            id: "close",
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide(false)), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createElementVNode("textarea", {
              class: "form-control miscnotes-textarea",
              rows: "6",
              value: _ctx.notes,
              readonly: "true"
            }, null, 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (hide(false)), ["prevent"]))
          }, " Back ")
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})